/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'selfie': {
    width: 60,
    height: 40,
    viewBox: '0 0 60 40',
    data: '<rect pid="0" width="60" height="40" rx="6" _fill="#62E2AA"/><circle pid="1" cx="30" cy="14" r="7" _fill="#2E48DA"/><path pid="2" d="M30 23c-7.732 0-14 4.477-14 10h28c0-5.523-6.268-10-14-10z" _fill="#2E48DA"/>'
  }
})



// WEBPACK FOOTER //
// ./src/assets/icons/selfie.js